export const ShareIcon = ({
  size = 24,
  color = 'white',
  className,
}: {
  size?: number
  color?: string
  className?: string
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      className={className}
      fill="none"
    >
      <g clipPath="url(#clip0_331_22218)">
        <g>
          <path
            d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"
            fill="black"
            fillOpacity="0.4"
          />
          <path
            d="M13 0.25C20.0416 0.25 25.75 5.95837 25.75 13C25.75 20.0416 20.0416 25.75 13 25.75C5.95837 25.75 0.25 20.0416 0.25 13C0.25 5.95837 5.95837 0.25 13 0.25Z"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="0.5"
          />
        </g>
        <g>
          <path
            d="M20 13C20 16.866 16.866 20 13 20C9.13401 20 6 16.866 6 13C6 9.13401 9.13401 6 13 6"
            stroke={color}
            strokeLinecap="round"
          />
          <path
            d="M17.5482 8.19942L14.9183 10.3959C13.6998 11.4136 12.9825 12.9097 12.9521 14.497V14.497M17.5482 8.19942V11.735M17.5482 8.19942H14.0127"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_331_22218">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
